// Updated PublicRoute.tsx (add loading handling from useTenant)

import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { useTenant } from '@/hooks/useTenant';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isCustomDomain, loading: tenantLoading } = useTenant(); // Add tenantLoading
  const location = useLocation();

  if (tenantLoading) {
    console.log('[PublicRoute] Tenant loading, showing spinner');
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <div className='text-center'>
          <div className='animate-spin rounded-full h-32 w-32 border-b-2 border-primary'></div>
          <p className='mt-4 text-muted-foreground'>Loading...</p>
        </div>
      </div>
    );
  }

  if (isCustomDomain && !location.pathname.startsWith('/portal')) {
    console.log(
      '[PublicRoute] Custom domain on public main route, redirecting to /portal/auth',
      {
        pathname: location.pathname,
      }
    );
    return <Navigate to='/portal/auth' replace />;
  }

  return <>{children}</>;
};
